/* eslint-disable no-nested-ternary */
/* eslint-disable no-shadow */
import Card from '@mui/material/Card';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import { makeStyles } from 'tss-react/mui';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import Skeleton from '@mui/material/Skeleton';
import { useTheme } from '@mui/material/styles';
import dynamic from 'next/dynamic';
import React, { useEffect, useRef, useState } from 'react';
import { isWebpSupported } from 'react-image-webp/dist/utils';
import { GET_POST_BODY } from '../../helpers/graphql/singlePost';
import graphQLClient from '../../helpers/graphQLClient';
import parseHtmlToReact from '../../helpers/parseHtmlToReact';
import shadow from '../../helpers/shadow';
import { getUser } from '../../helpers/token';
import BorderedText from './BorderedText';
import CommentItem from './Comments/CommentItem';
import PostComments from './Comments/PostComments';
import LargeSocialShareDialog from './LargeSocialShareDialog';
import MembersOnly from './MembersOnly';
import PostContent from './PostContent';
import PostImageHeader from './PostImageHeader';
import PostSocialShares from './PostSocialShares';
import PostTitle from './PostTitle';
import SimilarPosts from './SimilarPosts';
import SliderTags from './SliderTags';
import StickyVoteSlider from './StickyVoteSlider';
import VideoTitle from './VideoTitle';
import VoteDetailsBtn from './VoteDetailsBtn';
import TravelGuideLinkCard from './TravelGuideLinkCard';
import NewUserCard from './NewUserCard';
import SimpleHeader from 'components/Blog/SimpleHeader';
import { getLocationDetails } from 'helpers/getLocationDetails';
import TravelResources from 'components/Post/TravelResources';
import Link from 'next/link';
import SafetyWingBanner from './SafetyWingBanner';
// import { getRoles } from 'helpers/token';
import ExternalLinkModal from './ExternalLinkModal';

const PostSidebar = dynamic(() => import('./PostSidebar'), {
  ssr: false,
});
const MobilePostProfile = dynamic(() => import('./MobilePostProfile'), {
  ssr: false,
});
const VideoHeader = dynamic(() => import('./VideoHeader'), {
  ssr: false,
  loading: () => <Skeleton variant="rectangular" width="100%" height={400} />,
});
const PostLightbox = dynamic(() => import('./PostLightbox'), {
  ssr: false,
  loading: () => <></>,
});
const StickyBox = dynamic(() => import('react-sticky-box'), {
  ssr: false,
});

const SinglePost = props => {
  const { hostingUrl, isSimpleCover } = props;
  const {
    location,
    title,
    excerpt,
    createdAt,
    tags,
    author,
    isTf,
    permlink,
    _id,
    comments,
    totalSmiles,
    smiles,
    json,
    hasData,
    wordCount,
    readTime,
    community,
    youtubeId,
    blacklist,
    allImgDetails,
    cover,
    thumb,
    isUgcLinks,
  } = props.post;

  const theme = useTheme();

  const useStyles = makeStyles()(() => ({
    card: {
      borderRadius: 12,
      height: youtubeId ? undefined : '100%',
      boxShadow: shadow.lg,
      backgroundColor:
        theme.palette.mode === 'dark'
          ? 'rgba(53, 63, 68, 0.92)'
          : 'rgba(255, 255, 255, 0.92)',
      backdropFilter: 'blur(5px)',
    },
    whiteCard: {
      borderRadius: 12,
      height: youtubeId ? undefined : '100%',
      boxShadow: shadow.lg,
    },
  }));

  const { classes } = useStyles();

  const [body, setMemberBody] = useState(props.post.body);
  const [webpSupport, setWebpSupport] = useState(undefined);
  const [cardWidth, setCardWidth] = useState(1000);
  const [windowHeight, setWindowHeight] = useState(700);
  const [state, setState] = useState({
    title: 'Most smiles',
    userComment: undefined,
    lightboxIsOpen: false,
    lightboxIndex: 0,
  });
  const [chatOpen, setChatOpen] = useState(false);
  // const [roles, setRoles] = useState(undefined);
  const [externalLinkModal, setExternalLinkModal] = useState(undefined);

  // useEffect(() => {
  //   setRoles(getRoles());
  // }, []);

  const renderSidebar = useMediaQuery('(min-width: 992px)');

  const ref = useRef(null);

  const getMembersOnlyBody = () => {
    graphQLClient(GET_POST_BODY, {
      author: author.username,
      permlink,
    })
      .then(({ post }) => {
        if (post && post.body) setMemberBody(post.body);
      })
      .catch(err => console.log(err));
  };

  useEffect(() => {
    if (ref.current && ref.current.offsetWidth) {
      const newCardWidth =
        Math.round((ref.current.offsetWidth + 100) / 100) * 100;
      setCardWidth(newCardWidth);
    }
    setWebpSupport(isWebpSupported());
    setWindowHeight(window.innerHeight);
    if (!body && blacklist && blacklist.isMembersOnly && getUser())
      getMembersOnlyBody();
  }, []);

  useEffect(() => {
    if (props.post.body) setMemberBody(props.post.body);
  }, [props]);

  const toggleModal = () => {
    setState(state => ({ lightboxIsOpen: !state.lightboxIsOpen }));
  };

  const toggleLightbox = lightboxIndex => {
    setState(state => ({
      lightboxIsOpen: !state.lightboxIsOpen,
      lightboxIndex,
    }));
  };

  const onCommentAdd = userComment => {
    // eslint-disable-next-line no-param-reassign
    userComment.depth = 1;
    setState({ userComment });
  };

  let showAffiliateBox = false;
  // isSimpleCover ? false : true; //TODO: Don't show for paying subscribers => paying subscribers need a special role!. Also do not show for countries that are excluded from insurance (e.g. Cuba)
  // if (blacklist && blacklist.isBlacklistedFromPost) showAffiliateBox = false;
  // if (author.roles.indexOf('paid') !== -1) showAffiliateBox = false;
  // if (roles && roles.indexOf('paid') !== -1) showAffiliateBox = false;

  const reactParsed = parseHtmlToReact(body, {
    cardWidth,
    hideimgcaptions: !isTf,
    toggleLightbox,
    webpSupport,
    windowHeight,
    allImgDetails,
    showAffiliateBox: false,
    countryCode: location ? location.countryCode : undefined,
    setExternalLinkModal,
    isUgcLinks,
  });
  const { bodyText } = reactParsed;

  const Comments = (
    <>
      {state.userComment || comments ? (
        <div className="flex-grow-1">
          <BorderedText>Comments</BorderedText>
        </div>
      ) : (
        <></>
      )}
      {
        // "Fake" display new user comment after submitting comment without refreshing from the API
        state.userComment && (
          <Grid item lg={12} md={12} sm={12} xs={12} className="pb-2">
            <div className="pt-2 pr-2 pl-2">
              <CommentItem comment={state.userComment} hideReplyBtn />
            </div>
          </Grid>
        )
      }
      {comments !== 0 && (
        <>
          <div className="pr-2 pl-2">
            <PostComments rootId={_id} />
          </div>
        </>
      )}
    </>
  );

  const { locationTitle } = getLocationDetails(location);

  if (!body && (!blacklist || !blacklist.isMembersOnly) && !youtubeId)
    return <div style={{ height: '100vh' }} />;
  let coverImage;
  if (cover && cover.url) coverImage = cover;
  if (!coverImage && thumb && thumb.url) coverImage = thumb;
  return (
    <>
      <div
        className={`position-relative${
          youtubeId && wordCount < 250 ? '' : ' -tw-mt-[65px]'
        }`}
      >
        <>
          {isSimpleCover && (
            <SimpleHeader
              tags={tags}
              author={author}
              title={title}
              coverImage={coverImage}
              createdAt={createdAt}
              youtubeId={youtubeId}
            />
          )}
          <PostImageHeader
            coverImage={coverImage}
            author={author.username}
            permlink={permlink}
            tags={tags}
            title={title}
            thumbnail={thumb ? thumb.url : undefined}
            comments={comments}
            hideHeader={isSimpleCover || youtubeId || !coverImage}
          />
          {!coverImage && <div className="tw-mt-4" />}
          {!isSimpleCover && youtubeId && wordCount >= 250 && (
            <VideoHeader
              windowHeight={windowHeight}
              youtubeId={youtubeId}
              isFullWidth
              isSound
            />
          )}
          <div
            className={
              isSimpleCover
                ? 'tw-flex'
                : `container-fluid p-0 position-relative ${
                    youtubeId && wordCount < 250 ? '' : ' tw-pt-[45px]'
                  }`
            }
          >
            <div
              className={
                isSimpleCover
                  ? 'tw-mx-auto tw-w-full sm:tw-max-w-4xl'
                  : 'row justify-content-center no-gutters'
              }
            >
              {!isSimpleCover && coverImage && !youtubeId && (
                <div className="col-12">
                  <PostTitle
                    title={title}
                    createdAt={createdAt}
                    readTime={readTime}
                    wordCount={wordCount}
                    community={community}
                    location={location}
                  />
                </div>
              )}
              {isSimpleCover || (youtubeId && wordCount < 250) ? (
                <></>
              ) : (
                <div className="col-xl-1 col-0" />
              )}
              <div
                className={
                  isSimpleCover
                    ? 'm-auto'
                    : 'col-xl-8 col-lg-8 col-sm-11 col-12 pb-4 d-flex justify-content-end'
                }
              >
                <div
                  ref={ref}
                  id="post"
                  className={
                    isSimpleCover
                      ? 'tw-z-1 tw-relative'
                      : `${
                          youtubeId && wordCount < 250 ? 'w-100' : 'scaleWidth'
                        } h-100`
                  }
                >
                  {youtubeId && !isSimpleCover && (
                    <div className="pb-2">
                      {wordCount < 250 && (
                        <>
                          <div className="tw-pt-1" />
                          <VideoHeader
                            windowHeight={windowHeight}
                            youtubeId={youtubeId}
                            isSound
                            isRounded
                          />
                        </>
                      )}
                      <VideoTitle
                        title={title}
                        createdAt={createdAt}
                        readTime={readTime}
                        wordCount={wordCount}
                        location={location}
                        community={community}
                      />
                    </div>
                  )}
                  {!coverImage && !youtubeId && <div className="tw-mt-5" />}
                  <Card
                    className={
                      isSimpleCover ||
                      (!body && blacklist && blacklist.isMembersOnly)
                        ? classes.whiteCard
                        : classes.card
                    }
                  >
                    <div
                      className={
                        !body && blacklist && blacklist.isMembersOnly
                          ? 'lg:tw-h-[calc(100%-10rem)]'
                          : 'lg:tw-h-[calc(100%-46px)]'
                      }
                    >
                      <PostContent
                        hideHeader
                        authorAvatar={author.avatar}
                        author={author}
                        body={body}
                        permlink={permlink}
                        displayName={author.displayName}
                        createdAt={createdAt}
                        readTime={readTime}
                        wordCount={wordCount}
                        community={community}
                        content={
                          <>
                            <div
                              className={`textPrimary postCardContent postcontent postanchors${
                                !body && blacklist && blacklist.isMembersOnly
                                  ? ' fadeOutBody'
                                  : ''
                              }`}
                            >
                              {!isSimpleCover && !coverImage && !youtubeId && (
                                <VideoTitle
                                  postTitlePadding
                                  title={title}
                                  createdAt={createdAt}
                                  readTime={readTime}
                                  wordCount={wordCount}
                                  location={location}
                                  community={community}
                                />
                              )}
                              {!body && youtubeId ? (
                                <></>
                              ) : !body &&
                                blacklist &&
                                blacklist.isMembersOnly ? (
                                excerpt
                              ) : body && bodyText ? (
                                <>{bodyText}</>
                              ) : (
                                [
                                  0,
                                  1,
                                  2,
                                  3,
                                  4,
                                  5,
                                  6,
                                  7,
                                  8,
                                  9,
                                  10,
                                  11,
                                  12,
                                  13,
                                  14,
                                  15,
                                  16,
                                  17,
                                  18,
                                  19,
                                  20,
                                  21,
                                  22,
                                  23,
                                  24,
                                  25,
                                  26,
                                ].map(key => (
                                  <Skeleton
                                    key={key}
                                    variant="text"
                                    width="100%"
                                    height={25}
                                  />
                                ))
                              )}
                            </div>
                            {!body && blacklist && blacklist.isMembersOnly && (
                              <>
                                <div className="fadeOut" />
                                <div className="fadeOutOver">
                                  <MembersOnly
                                    hostingUrl={hostingUrl}
                                    author={author}
                                  />
                                </div>
                              </>
                            )}
                            {showAffiliateBox &&
                              body &&
                              bodyText &&
                              (!blacklist || !blacklist.isMembersOnly) && (
                                <div
                                  className={`textPrimary postCardContent postcontent postanchors`}
                                >
                                  <TravelResources
                                    author={author.username}
                                    showRemoveAds
                                    setChatOpen={setChatOpen}
                                    countryCode={
                                      location
                                        ? location.countryCode
                                        : undefined
                                    }
                                  />
                                  <p className="tw-mt-6">
                                    Disclosure: Posts on TravelFeed may contain
                                    affiliate links.{' '}
                                    <Link href="/about/affiliate-disclosure">
                                      See affiliate disclosure
                                    </Link>
                                    .
                                  </p>
                                </div>
                              )}
                          </>
                        }
                        location={location}
                        tags={tags}
                        title={title}
                        thumbnail={thumb ? thumb.url : undefined}
                      />
                    </div>
                    {hasData && (
                      <div className="d-none d-xl-none d-lg-none d-sm-none d-md-block">
                        <Divider variant="middle" />
                        <Typography
                          variant="h5"
                          className="pt-4"
                          align="center"
                          gutterBottom
                        >
                          Share this post
                        </Typography>
                        <PostSocialShares
                          author={author.username}
                          permlink={permlink}
                          tags={tags}
                          title={title}
                          thumbnail={thumb ? thumb.url : undefined}
                        />
                      </div>
                    )}
                    {!renderSidebar && !isSimpleCover && (
                      <MobilePostProfile
                        youtubeChannelId={
                          author.username === 'bombtravelvids'
                            ? json
                            : undefined
                        }
                        author={author}
                        isYoutube={youtubeId}
                      />
                    )}
                    <Divider variant="middle" />
                    <div className="pb-4">
                      <VoteDetailsBtn
                        numberreplies={comments}
                        votes={smiles}
                        totalSmiles={totalSmiles}
                      />{' '}
                      {hasData && tags && tags.length > 0 && (
                        <SliderTags tags={tags} />
                      )}
                    </div>

                    {(isSimpleCover || youtubeId) && (
                      <>
                        {smiles !== undefined && (
                          <StickyVoteSlider
                            chatOpen={chatOpen}
                            isRelative
                            author={author.username}
                            permlink={permlink}
                            id={_id}
                            title={title}
                            smiles={smiles}
                            totalSmiles={totalSmiles}
                            noOfComments={comments}
                            onCommentAdd={onCommentAdd}
                            locationTitle={locationTitle}
                          />
                        )}
                      </>
                    )}
                  </Card>
                  {(youtubeId || isSimpleCover) && (
                    <div className="pt-2">{Comments}</div>
                  )}
                </div>
              </div>
              <div className="col-xl-3 col-lg-4 d-none d-xl-block d-lg-block pl-0 sidebartop">
                {renderSidebar && !isSimpleCover && (
                  <StickyBox offsetTop={65} offsetBottom={10}>
                    <div className="scaleWidth tw-relative tw-z-[901] tw-pb-20">
                      <div className="container">
                        <PostSidebar
                          youtubeChannelId={
                            author.username === 'bombtravelvids'
                              ? json
                              : undefined
                          }
                          author={author}
                          location={location}
                          isYoutube={youtubeId}
                        />
                      </div>
                    </div>
                  </StickyBox>
                )}
              </div>
            </div>
          </div>
          {!youtubeId && !isSimpleCover && smiles !== undefined && (
            <StickyVoteSlider
              chatOpen={chatOpen}
              author={author.username}
              permlink={permlink}
              id={_id}
              title={title}
              smiles={smiles}
              totalSmiles={totalSmiles}
              noOfComments={comments}
              onCommentAdd={onCommentAdd}
              locationTitle={locationTitle}
            />
          )}
        </>
        <Grid container spacing={0} alignItems="center" justifyContent="center">
          <div className="tw-block lg:tw-hidden m-4">
            <div className="tw-m-auto tw-max-w-lg">
              <NewUserCard isRounded />
              {showAffiliateBox && (
                <div className="tw-flex tw-justify-center">
                  <div className="tw-w-72 tw-h-56">
                    <SafetyWingBanner />
                  </div>
                </div>
              )}
            </div>
          </div>
          <Grid item lg={8} md={9} sm={11} xs={12} className="pb-2">
            <div className="anchor" id="comments" name="comments" />
          </Grid>
          {!youtubeId && !isSimpleCover && (
            <div className="container-fluid">
              <div className="row justify-content-center">
                <div className="d-flex justify-content-center col-xl-8 col-lg-9 col-sm-11 col-12 pb-4">
                  <div className="scaleWidth">{Comments}</div>
                </div>
              </div>
            </div>
          )}
          {!isSimpleCover && (
            <Grid item lg={11} md={11} sm={11} xs={12} className="pb-5">
              <div className="pt-2">
                <SimilarPosts
                  community={community}
                  countryCode={location ? location.countryCode : undefined}
                  coordinates={
                    location && location.coordinates
                      ? location.coordinates.coordinates
                      : undefined
                  }
                />
              </div>
            </Grid>
          )}
        </Grid>
        {location && location.countryCode ? (
          <div className="tw-block lg:tw-hidden m-4">
            <div className="tw-m-auto tw-max-w-lg">
              <TravelGuideLinkCard
                countryCode={location.countryCode}
                isRounded
              />
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
      {allImgDetails && allImgDetails.length > 0 && (
        <PostLightbox
          lightboxIsOpen={state.lightboxIsOpen}
          toggleModal={toggleModal}
          images={allImgDetails}
          lightboxIndex={state.lightboxIndex}
          isWebp={webpSupport}
        />
      )}
      <LargeSocialShareDialog
        author={author.username}
        permlink={permlink}
        tags={tags}
        title={title}
        thumbnail={thumb ? thumb.url : undefined}
        createdAt={createdAt}
      />
      <ExternalLinkModal
        externalLinkModal={externalLinkModal}
        setExternalLinkModal={setExternalLinkModal}
      />
      <style jsx>{`
        .scaleWidth {
          width: 100%;
        }
        .fadeOutBody {
          height: 180px;
          position: relative;
          overflow: hidden;
        }
        .fadeOut {
          top: -180px;
          position: relative;
          height: 180px;
          width: 100%;
          background-image: linear-gradient(
            to bottom,
            transparent,
            ${theme.palette.mode === 'dark' ? '#353F44' : '#FFFFFF'}
          );
        }
        .fadeOutOver {
          width: 100%;
          position: relative;
          margin-top: -180px;
          margin-bottom: 100px;
        }
        .sidebartop: {
          padding-top: 20px;
        }
        @media (min-width: 1200px) {
          .sidebartop {
            padding-top: ${!isSimpleCover && !youtubeId && coverImage
              ? `${windowHeight + 20}px`
              : '20px'};
          }
        }
        @media (min-width: 1500px) {
          .scaleWidth {
            width: 85%;
          }
        }
        @media (min-width: 1700px) {
          .scaleWidth {
            width: 75%;
          }
        }
      `}</style>
    </>
  );
};

export default SinglePost;
